import React, { useContext, useMemo } from 'react';
import * as PropTypes from 'prop-types';

import { EnablerFeatures } from 'consts/consts';
import { DataContext, LoadingContext, LocaleContext } from 'contexts';
import TableHeader from './TableHeader';
import EmptyResults from '../EmptyResults';
import TablePreloader from './TablePreloader';
import TableRow from './TableRow';

import styles from './styles.modules.scss';

const DesktopResults = ({showCount, onChangeVisibility}) => {
    const { searchResults, enablerFeatures } = useContext(DataContext);
    const { isGlobalLoading } = useContext(LoadingContext);
    const locale = useContext(LocaleContext);

    const totalCount = useMemo(() => searchResults?.result?.length || 0, [searchResults]);

    const tableContentJSX = useMemo(() => totalCount > 0
        ? searchResults.result.slice(0, showCount).map((item, index) => (
            <TableRow
                key={item.key}
                num={index+1}
                value={item}
                onChangeVisibility={onChangeVisibility}
            />
        ))
        : <EmptyResults/>
    , [searchResults, showCount, totalCount, onChangeVisibility]);

    return (
        <div className={styles['table']}>
            <TableHeader
                locale={locale}
                popoverFeature={enablerFeatures[EnablerFeatures.selectAndInviteAllTruckersInformer]}
                showCount={showCount}
            />
            {isGlobalLoading || !searchResults ? <TablePreloader/> : tableContentJSX}
        </div>
    );
};

export default DesktopResults;

DesktopResults.propTypes = {
    showCount: PropTypes.number,
    onChangeVisibility: PropTypes.func,
};
